import { FC, ReactNode } from "react";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import Image from "next/image";
import { Slider } from "@/lib/types/Slider";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { useHomePageContext } from "@/src/features/home/HomePageContext";
import { useAppContext } from "@/src/config/AppProvider";
import DOMPurify from "isomorphic-dompurify";

const SliderBanner = (): ReactNode => {
  const { sliders } = useHomePageContext();

  return (
    <div className="rbt-banner-area rbt-banner-11 bg-color-darker ptb--100">
      <div className="wrapper">
        <div className="container">
          <Swiper
            loop
            className="swiper swiper-initialized swiper-horizontal rbt-arrow-between swiper-backface-hidden"
            slidesPerView={1}
            modules={[Navigation, Autoplay]}
            navigation={{
              nextEl: ".rbt-arrow-right",
              prevEl: ".rbt-arrow-left"
            }}
            autoplay={{
              delay: 4000,
              pauseOnMouseEnter: true
            }}
          >
            {sliders
              .sort((a, b) => a.DisplayOrder - b.DisplayOrder)
              .map(data => (
                <SwiperSlide className="swiper-wrapper" key={data.IdGuid}>
                  <Slide data={data} />
                </SwiperSlide>
              ))}
            <div className="rbt-swiper-arrow rbt-arrow-left">
              <div className="custom-overfolow">
                <i className="rbt-icon feather-arrow-left"></i>
                <i className="rbt-icon-top feather-arrow-left"></i>
              </div>
            </div>
            <div className="rbt-swiper-arrow rbt-arrow-right">
              <div className="custom-overfolow">
                <i className="rbt-icon feather-arrow-right"></i>
                <i className="rbt-icon-top feather-arrow-right"></i>
              </div>
            </div>
          </Swiper>
        </div>
      </div>
    </div>
  );
};

interface ISlideProps {
  data: Slider;
}

const Slide: FC<ISlideProps> = ({ data }) => {
  const { licenceSettings, getLocalization } = useAppContext();
  const { t } = useTranslation();

  return (
    <SwiperSlide className="swiper-wrapper">
      <div className="swiper-slide">
        <div className="row gy-5 row--30 align-items-center">
          <div className="col-lg-6">
            <div className="course-thumbnail">
              <Image
                className="radius-6"
                src={data.ImageUrl}
                width={623}
                height={398}
                priority
                alt={licenceSettings.SiteDescription}
                style={{
                  objectFit: "cover",
                  maxHeight: 398
                }}
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="content">
              <div className="inner text-start">
                <div className="section-title">
                  <span className="subtitle bg-secondary-opacity">{getLocalization("homeEmphasis")}</span>
                </div>
                <h2 className="banner-title" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.Title) }}></h2>
                <p className="description has-medium-font-size mt--20" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.Description) }}></p>
                <div className="slider-btn rbt-button-group justify-content-start">
                  <Link
                    className="rbt-moderbt-btn"
                    href={data.Link}
                    style={{
                      color: "#FFF"
                    }}
                  >
                    <span className="moderbt-btn-text">{t("moreInformation")}</span>
                    <i className="feather-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SwiperSlide>
  );
};

export default SliderBanner;
